<template>
  <div v-if="itemLoaded" class="row" id="item-details">
    <div class="col-lg-12 col-md-12">
      <h1>{{ item.itemName }}</h1>
    </div>
    <div class="col-lg-8 col-md-12">
      <div class="qm-panel">
        <form v-on:change="updateItem">
          <h2>Additional information</h2>
          <div class="row">
            <div class="col-md-4 col-6">
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input" type="checkbox" v-model="item.disassembly">
                  Disassembly
                </label>
              </div>
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input" type="checkbox" v-model="item.assembly">
                  Assembly
                </label>
              </div>
            </div>
            <div class="col-md-8 col-6">
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input" type="checkbox" v-model="item.disassembly3rd">
                  3rd party needed
                </label>
              </div>
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input" type="checkbox" v-model="item.assembly3rd">
                  3rd party needed
                </label>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-12">
              <p>Packing</p>
            </div>
            <div class="col-md-4 col-6">
              <div v-for="packing in packingOptions" class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input" type="radio" name="packing" v-model="item.packing" :value="packing.value">
                  {{ packing.label }}
                </label>
              </div>
            </div>
            <div class="col-md-8 col-6">
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input" type="checkbox" v-model="item.packedByOwner">
                  Packed by owner
                </label>
              </div>
            </div>
          </div>
          <hr />
          <div class="form form-inline qm-item-weight">
            <label for="weight" class="col-form-label col-4">Weight</label>
            <div class="form form-inline col-8">
              <input v-model="item.weight" type="number" id="weight" min="0" class="form-control" v-bind:class="{ important: weightIsNull }"><span class="unit">{{ weightUnit }} ({{ itemDensity }} {{ weightUnit }}/{{ volumeUnit }})</span>
            </div>
          </div>
          <hr />
          <div class="row">
            <label for="crateType" class="col-form-label col-4">Crate</label>
            <div class="col-8" style="margin-bottom:1rem;padding-left:0.25rem;">
              <select v-model="selectedCrate" v-on:change="updateCrateType" id="crateType" class="custom-select">
                <option v-for="crate in crates" v-bind:value="crate.id">{{ crate.text }}</option>
              </select>
            </div>
            <div class="col-md-4 col-sm-4 col-12 form form-inline">
              <label for="itemCrateL" class="col-form-label col-4">L&nbsp;(mm)</label>
              <input v-model="item.crateL" type="number" id="itemCrateL" class="form-control col-8">
            </div>
            <div class="col-md-4 col-sm-4 col-12 form form-inline">
              <label for="itemCrateW" class="col-form-label col-4">W&nbsp;(mm)</label>
              <input v-model="item.crateW" type="number" id="itemCrateW" class="form-control col-8">
            </div>
            <div class="col-md-4 col-sm-4 col-12 form form-inline">
              <label for="itemCrateH" class="col-form-label col-4">H&nbsp;(mm)</label>
              <input v-model="item.crateH" type="number" id="itemCrateH" class="form-control col-8">
            </div>
          </div>
          <hr />
          <h3 id="commentsLabel">Comments</h3>
          <textarea v-model="item.comments" id="comments" class="form-control" rows="3" aria-labelledby="commentsLabel"></textarea>
        </form>
      </div>
    </div>
    <div class="col-lg-4 col-md-12">
      <div class="qm-panel">
        <h2>Photos</h2>
        <foto-list :mode="'item'" :maxFotos="6"></foto-list>
      </div>
    </div>
    <div class="col-lg-3 col-md-3 mb-4"></div> <!-- Avoid button on the left, close to the iPad keyboard's Undo button -->
    <div class="col-lg-2 col-md-2">
      <button v-on:click="deleteItemConfirm" type="button" class="btn btn-warning qm-survey-edit-button">
        <i class="fa fa-trash"></i> Delete item
      </button>
      <button v-if="confirmItemDelete" id="delete-item-button" @click="deleteItem" type="button" class="btn btn-danger qm-survey-edit-button">
        Really <i class="fa fa-question-circle"></i>
      </button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import FotoList from './children/FotoList.vue'
  export default {
    name: 'ItemDetail',
    components: {
      'foto-list': FotoList
    },
    data: () => ({
      itemLoaded: false,
      confirmItemDelete: false,
      selectedCrate: null,
      packingOptions: [
        {
          label: 'default',
          value: ''
        },
        {
          label: 'Blanket',
          value: 'Blanket'
        },
        {
          label: 'Full Export',
          value: 'Full'
        }
      ]
    }),
    computed: {
      itemStorageKey () {
        return 'survey-' + this.session.surveyId + '-room-' + this.session.roomId + '-item-' + this.session.itemId
      },
      ...mapGetters({
        session: 'getSession',
        item: 'getItem'
      }),
      itemDensity () {
        return (this.item.weight === null || this.item.volume === null) ? 0 : Math.round(this.item.weight / this.item.volume * 100) / 100
      },
      weightIsNull () {
        if (this.item.weight === null) {
          return true
        } else {
          return false
        }
      },
      crates () {
        var crates = this.$store.getters.getAllCrates
        crates.unshift({ id: 0, text: '--- select ---' })
        return crates
      },
      volumeUnit () {
        if (this.$hasMetricUnits()) {
          return 'Cbm'
        } else {
          return 'Cuft'
        }
      },
      weightUnit () {
        if (this.$hasMetricUnits()) {
          return 'Kg'
        } else {
          return 'lbs'
        }
      }
    },
    created: function () {
      this.$store.dispatch('loadSession').then(() => {
        this.$store.dispatch('loadAllCrates').then(() => {
          this.$store.dispatch('loadItem', this.itemStorageKey).then(() => {
            this.itemLoaded = true
            this.selectedCrate = this.item.crateType
          })
        })
      })
    },
    methods: {
      updateItem () {
        this.$store.dispatch('updateItem',
          {
            storageKey: String(this.itemStorageKey),
            item: this.item
          }
        )
      },
      updateCrateType () {
        this.item.crateType = this.selectedCrate
      },
      deleteItemConfirm () {
        this.confirmItemDelete = !this.confirmItemDelete
      },
      deleteItem () {
        this.$store.dispatch('deleteItemFotos', this.item.itemId).then(() => {
          this.$store.dispatch('deleteItem', this.itemStorageKey).then(() => {
            this.$store.dispatch('selectItem', null).then(() => {
              this.$router.go(-1)
            })
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ItemDetail.vue